import React, { useCallback, useEffect, useRef, useState } from "react";
import { getCandidateData } from "../../utility/candidate-data";
import * as adobeAnalytics from "../../utility/adobe-analytics";
import { useParams } from "react-router-dom";
import { I9Controlled, I9Response } from "./i9-controlled";
import { ErrorCode } from "./i9-error-message";
import { getCaasInfo } from "../../service/get-caas-info";
import { isDragonstone } from "../../helpers/url-params";

interface I9TaskProps {
  isExpanded?: boolean;
}

export const I9Task = ({ isExpanded }: I9TaskProps) => {
  const { applicationId, requisitionId } = useParams<{
    applicationId: string;
    requisitionId: string;
  }>();
  const [loading, setLoading] = useState(true);
  const [i9ErrorCode, setI9ErrorCode] = useState<ErrorCode | undefined>();
  const [i9Response, setI9Response] = useState<I9Response>({});
  const refIsExpanded = useRef(false);

  const i9LinkAccessor = useCallback(async () => {
    const { candidateId } = await getCandidateData(applicationId);
    return getCaasInfo(candidateId);
  }, [applicationId]);

  const trackI9LinkClick = useCallback(() => {
    adobeAnalytics.addPageLoadMetric(window, applicationId, "i9advantage", {
      jobId: requisitionId,
      isDragonstone: isDragonstone(requisitionId),
    });
  }, [applicationId, requisitionId]);

  const requestI9Link = useCallback(async () => {
    setLoading(true);
    try {
      const response = await i9LinkAccessor();
      setI9Response(response);

      if (response.errorCode) {
        setI9ErrorCode(response.errorCode.toString() as ErrorCode);
      } else {
        setI9ErrorCode(undefined);
      }
    } catch (e) {
      setI9ErrorCode(ErrorCode.Internal);
    }
    setLoading(false);
  }, [i9LinkAccessor]);

  useEffect(() => {
    if (refIsExpanded.current === false && isExpanded === true) {
      refIsExpanded.current = true;
      requestI9Link();
    }
  }, [isExpanded]);

  return (
    <I9Controlled
      showStatus
      loading={loading}
      i9Response={i9Response}
      i9ErrorCode={i9ErrorCode}
      onRetry={requestI9Link}
      onSubmit={trackI9LinkClick}
    />
  );
};
